import Box, { disableSystemPropsKey } from "./Box";
import resolveStyledProps from "./resolveStyledProps";
import useTheme from "./useTheme";
import clsx from "clsx";
import { createMemo } from "solid-js";
import { splitProps } from "solid-js";
export const skipProps = [
    "ownerState",
    "theme",
    "sx",
    "as",
];
function resolveStyles(theme, className, styles, inProps) {
    return createMemo(() => styles.reduce((result, style) => {
        let styledProps;
        if (typeof style === "function") {
            styledProps = style({
                ownerState: inProps.ownerState,
                theme,
                sx: inProps.sx,
                as: inProps.as,
                props: inProps,
            });
        }
        else if (style) {
            styledProps = style;
        }
        if (styledProps)
            result.push({
                ["name"]: className,
                ...resolveStyledProps(styledProps),
            });
        return result;
    }, []));
}
function createStyled(config) {
    return function styled(Component, options = {}) {
        let className;
        if (options.name) {
            const slot = options.slot || "Root";
            className = `${options.name}-${slot.slice(0, 1).toLowerCase() + slot.slice(1)}`;
        }
        return function (...styles) {
            return function (inProps) {
                const theme = config?.onUseTheme
                    ? config.onUseTheme()
                    : useTheme();
                const [, otherProps] = splitProps(inProps, options.skipProps ?? skipProps);
                const inStyles = resolveStyles(theme, className || "css", styles, inProps);
                const inSx = createMemo(() => !options.skipSx && inProps.sx
                    ? Array.isArray(inProps.sx)
                        ? inProps.sx
                        : [inProps.sx]
                    : []);
                const sx = () => [...inStyles(), ...inSx()];
                if (typeof Component === "string") {
                    return (<Box {...otherProps} component={inProps.as || inProps.component || Component} sx={sx()} theme={theme} class={clsx([inProps.class, className])} {...{
                        [disableSystemPropsKey]: true,
                    }}/>);
                }
                return (<Component {...otherProps} component={inProps.as} sx={sx()} theme={theme} class={clsx([inProps.class, className])} ownerState={inProps.ownerState}/>);
            };
        };
    };
}
export default createStyled;
